import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { SpecificationRepository, SpecificationStatus } from '../../services/specification-repository';
import { SpecificationContentType, SpecificationStep } from '../../enums';
import { GetTaskDetail } from '@/infrastructure/api-functions/core-drafting-api/get-task-detail-api';

@injectable()
export class SpecificationRepositoryImpl implements SpecificationRepository {
    constructor(
        @inject(GetTaskDetail)
        private _getTaskDetailApi: GetTaskDetail<SpecificationContentType, SpecificationStep>,
    ) {}

    async getSpecificationStatus(taskId: string): Promise<SpecificationStatus> {
        const response = await this._getTaskDetailApi.getTaskDetail(taskId);
        const step = response.current_step ?? SpecificationStep.Empty;
        return {
            step,
            wireframeExtractConfig: {
                enabled: response.wireframeExtractConfig?.enabled ?? false,
                remainingCount: response.wireframeExtractConfig?.remainingCount ?? 0,
                totalCount: response.wireframeExtractConfig?.totalCount ?? 0,
            },
        };
    }
}
